import { z } from "zod";

/**
 * The shipping label a driver scanned, resolved to its leg without moving it.
 *
 * A plain string rather than a uuid, deliberately. The handler answers a code that names no unit
 * of this organisation with `UnknownShippingLabelError`, and a mis-read barcode should get that
 * same answer rather than a validation error — "this is not one of our labels" is what the person
 * holding the box needs to hear, and a 400 tells them nothing they can act on.
 */
export const getTransportOrderLabelParamSchema = z.object({
	code: z.string().min(1),
});

export type GetTransportOrderLabelParamSchema = z.infer<typeof getTransportOrderLabelParamSchema>;
